import { LoaderFunctionArgs } from 'react-router-dom';
import { Technology } from '../../backend/models/technology';
import { getPersons, getTechnology } from '../Util/server';
import { msalInstance } from '..';
import { Person } from '../../backend/models/person';

export type TechnologyLoaderResult = { technology: Technology; persons: Person[] };

const TechnologyLoader = async ({ params }: LoaderFunctionArgs): Promise<TechnologyLoaderResult> => {
  const loggedIn = Boolean(msalInstance.getActiveAccount());
  if (!loggedIn) {
    return {
      technology: { id: '', name: '' },
    } as TechnologyLoaderResult;
  }
  const [technology, persons] = await Promise.all([getTechnology(params.name), getPersons()]);
  return { technology, persons };
};

export default TechnologyLoader;
